import styled from 'styled-components';

import { useTypedParams } from '@sorare/routing';

import { Portal } from '@sorare/core/src/atoms/layout/Portal';
import { useIsLaptop } from '@sorare/core/src/hooks/device/useIsLaptop';

import { CollectionSetBackground } from 'components/myCards/CollectionSetBackground';

import type { PageParams } from './__generated__/routeParams';

const BlackGradientOverlay = styled.div`
  position: absolute;
  inset: 0;
  background: linear-gradient(
    180deg,
    rgba(var(--c-rgb-black), 0.4) 0%,
    var(--c-black) 100%
  );
`;

const MyCardsCardsTypeSetPage = () => {
  const { set } = useTypedParams<PageParams>();
  const isLaptopAndAbove = useIsLaptop();
  if (isLaptopAndAbove) {
    return null;
  }
  return (
    <Portal id="page-background">
      <CollectionSetBackground set={set} />
      <BlackGradientOverlay />
    </Portal>
  );
};

export default MyCardsCardsTypeSetPage;
